import i18next from 'i18next';
import translates from '../i18n/*.json';
import {
  getUrlParameter
} from '../utils/get-url-param';

export const langsArr = Object.keys(translates);


const lng = getLang();
const resources = langsArr.reduce((res, curr) => {
  return {
    ...res,
    [`${ curr }`]: {
      translation: {
        ...translates[`${ curr }`]
      }
    }
  }
}, {});

i18next.init({
  lng,
  debug: false,
  resources
});

function transformTag(tag, attr) {
  const tagVal = tag.dataset[`${ attr }`].split('|');
  const key = tagVal[0].trim();
  const params = tagVal[1] ? JSON.parse(tagVal[1]) : {};
  return {
    key,
    params
  };
}

// to translate vars - use in html data-i18n='key | { "test": "1" }'
export function setTranslates(t, l) {
  const html = document.querySelector('html');
  let lang = l;
  if (lang === 'cz') {
    lang = 'cs';
  }
  if (lang === 'ua') {
    lang = 'uk';
  }
  html.setAttribute('lang', lang);

  const tagsArr = document.querySelectorAll('[data-i18n]');
  tagsArr.forEach((tag) => {
    const {
      key,
      params
    } = {
      ...transformTag(tag, 'i18n')
    };
    tag.innerHTML = t(key, params);
  });

  const altArr = document.querySelectorAll('[data-i18n-alt]');
  altArr.forEach((tag) => {
    const {
      key,
      params
    } = {
      ...transformTag(tag, 'i18nAlt')
    };
    tag.setAttribute('alt', t(key, params));
  });

  const placeholderArr = document.querySelectorAll('[data-i18n-placeholder]');
  placeholderArr.forEach((tag) => {
    const {
      key,
      params
    } = {
      ...transformTag(tag, 'i18nPlaceholder')
    };
    tag.setAttribute('placeholder', t(key, params));
  });

  const hrefArr = document.querySelectorAll('[data-i18n-href]');
  hrefArr.forEach((tag) => {
    const {
      key,
      params
    } = {
      ...transformTag(tag, 'i18nHref')
    };
    tag.setAttribute('href', t(key, params));
  });
}


export function getLang() {
  const linkLang = getUrlParameter('lang');
  if (linkLang) {
    return linkLang;
  }

  const storageLanguage = localStorage.getItem('grv-refferal-lang');
  if (storageLanguage) {
    return storageLanguage;
  }
  const langRE = /^\/?(es|en|cs|pl|uk|ru)/;
  let browserLanguage = navigator.language.match(langRE) && navigator.language.match(langRE)[0] || 'en';
  if (browserLanguage === 'cs') {
    browserLanguage = 'cz';
  }
  if (browserLanguage === 'uk') {
    browserLanguage = 'ua';
  }
  localStorage.setItem('grv-refferal-lang', browserLanguage);
  return browserLanguage;
}

export function setLang(lang) {
  localStorage.setItem('grv-refferal-lang', lang);
}